import { AlertBadge } from '.';
import { useAlert } from '../hooks/useAlert';

function SimpleAlert({ alert, className }) {
  return <AlertBadge alert={alert} className={className} />;
}

// Attach the hook as a static method for convenient access
SimpleAlert.useAlert = useAlert;

export default SimpleAlert;
